/**
 * The clock, for the shell (SideDrawer, AppLayout): a lazy chunk, so the
 * first load carries none of it (`npm run check:bundle`). The lock's rules
 * (`panelLock.ts`) are small and stay in the shell; only the button waits.
 */
import { lazy, Suspense, type ComponentProps } from 'react';

const Button = lazy(() => import('./PanelLockButton').then(m => ({ default: m.PanelLockButton })));

export function LazyPanelLockButton(props: ComponentProps<typeof Button>) {
    return <Suspense fallback={null}><Button {...props} /></Suspense>;
}
